import config from "environment";
import { getRequest, postRequest } from "./client";
import { 
    FormThemeExtended,
    RenameFormThemePayload, 
    CreateFormThemeInWorkspacePayload,
    UpdateFormThemePayload
} from "effno-core";

const { baseApi } = config;

export async function apiGetFormTheme(id: string) : Promise<FormThemeExtended | null> {
  const fetchURL = `${baseApi}/themes/${id}`;
  return await getRequest(fetchURL, "API/apiGetFormTheme");
}

export async function apiGetFormThemesForWorkspace(workspaceId: string) : Promise<FormThemeExtended[] | null> {
  const fetchURL = `${baseApi}/themes/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetFormThemesForWorkspace");
}

export async function apiCreateFormThemeInWorkspace(payload: CreateFormThemeInWorkspacePayload ) : Promise<FormThemeExtended | null> {
  const fetchURL = `${baseApi}/themes/create`;
  return await postRequest(fetchURL, payload, "API/apiRenameFormTheme");
}

export async function apiDeleteFormTheme(formThemeId: string) : Promise<FormThemeExtended | null> {
  const fetchURL = `${baseApi}/themes/delete/${formThemeId}`;
  return await getRequest(fetchURL, "API/apiDeleteFormTheme");
}

export async function apiRenameFormTheme(payload: RenameFormThemePayload) 
: Promise<FormThemeExtended | null> {
  const fetchURL = `${baseApi}/themes/rename`;
  return await postRequest(fetchURL, payload, "API/apiRenameTag");
}

export async function apiUpdateFormTheme(payload: UpdateFormThemePayload) 
: Promise<FormThemeExtended | null> {
  const fetchURL = `${baseApi}/themes/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdateFormTheme");
}
